import Microgame from '../engine/Microgame.js';

export default class ScratchGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Gratte !`, en: `Scratch!`, es: `¡Rasca!` },
            controls: { fr: `Frotte l'écran avec ton doigt ou ta souris`, en: `Rub the screen with your finger or mouse`, es: `Frota la pantalla con tu dedo o ratón` },
            objective: { fr: `Gratte complètement le ticket pour découvrir la surprise`, en: `Scratch the whole ticket to reveal the surprise`, es: `Rasca todo el boleto para revelar la sorpresa` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" stroke-width="2"><path d="M17 3v18l-3-3-3 3-3-3-3 3V3c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2Z"/></svg>`,
            actions: [
                { type: 'swipe', fromX: 30, fromY: 45, toX: 70, toY: 45, duration: 220 },
                { type: 'swipe', fromX: 70, fromY: 55, toX: 30, toY: 55, duration: 220 },
                { type: 'swipe', fromX: 30, fromY: 65, toX: 70, toY: 65, duration: 220 },
                { type: 'swipe', fromX: 70, fromY: 40, toX: 30, toY: 40, duration: 220 },
                { type: 'wait', duration: 320 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.canvas = null;
        this.ctx = null;
        this.isScratching = false;
        this.checkpoints = [];
        this.clearedCheckpoints = 0;
    }

    setup() {
        this.engine.ui.instruction.textContent = "DECRYPT!";

        // Hidden Code (Primary)
        const code = document.createElement('div');
        code.style.position = 'absolute';
        code.style.width = '300px';
        code.style.height = '100px';
        code.style.left = '50%';
        code.style.top = '50%';
        code.style.transform = 'translate(-50%, -50%)';
        code.style.display = 'flex';
        code.style.justifyContent = 'center';
        code.style.alignItems = 'center';
        code.style.color = this.primaryColor;
        code.style.fontSize = '4rem';
        code.style.fontWeight = 'bold';
        code.style.fontFamily = 'monospace';
        code.style.textShadow = `0 0 10px ${this.primaryColor}`;
        code.style.letterSpacing = '10px';
        code.textContent = "7 7 7";
        this.container.appendChild(code);

        // Scratch Layer (Secondary)
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.container.clientWidth;
        this.canvas.height = this.container.clientHeight;
        this.canvas.style.position = 'absolute';
        this.canvas.style.top = '0';
        this.canvas.style.left = '0';
        this.container.appendChild(this.canvas);

        this.ctx = this.canvas.getContext('2d');

        const rect = code.getBoundingClientRect();
        const containerRect = this.container.getBoundingClientRect();

        this.targetX = rect.left - containerRect.left;
        this.targetY = rect.top - containerRect.top;
        this.targetW = rect.width;
        this.targetH = rect.height;

        // Fill target area
        this.ctx.fillStyle = this.secondaryColor;
        this.ctx.fillRect(this.targetX - 20, this.targetY - 20, this.targetW + 40, this.targetH + 40);

        // Noise
        this.ctx.fillStyle = 'rgba(255,255,255,0.1)';
        for (let i = 0; i < 100; i++) {
            this.ctx.fillRect(
                this.targetX - 20 + Math.random() * (this.targetW + 40),
                this.targetY - 20 + Math.random() * (this.targetH + 40),
                5, 5
            );
        }

        // Create Checkpoints (Grid over text)
        const rows = 4;
        const cols = 8;
        const cellW = this.targetW / cols;
        const cellH = this.targetH / rows;

        for (let r = 0; r < rows; r++) {
            for (let c = 0; c < cols; c++) {
                this.checkpoints.push({
                    x: this.targetX + c * cellW + cellW / 2,
                    y: this.targetY + r * cellH + cellH / 2,
                    hit: false
                });
            }
        }

        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);

        this.engine.input.element.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    onDown(e) {
        if (!this.active) return;
        this.isScratching = true;
        this.scratch(e);
    }

    onMove(e) {
        if (!this.active || !this.isScratching) return;
        this.scratch(e);
    }

    onUp() {
        this.isScratching = false;
    }

    scratch(e) {
        const rect = this.canvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const radius = 26;

        this.ctx.globalCompositeOperation = 'destination-out';
        this.ctx.beginPath();
        this.ctx.arc(x, y, radius, 0, Math.PI * 2);
        this.ctx.fill();
        this.ctx.globalCompositeOperation = 'source-over';

        // Check collision with checkpoints
        this.checkpoints.forEach(cp => {
            if (!cp.hit) {
                const dx = x - cp.x;
                const dy = y - cp.y;
                if (dx * dx + dy * dy < radius * radius) {
                    cp.hit = true;
                    this.clearedCheckpoints++;
                }
            }
        });

        this.checkWin();
    }

    checkWin() {
        if (this.won) return;

        // Win if 85% of checkpoints are hit
        if (this.clearedCheckpoints / this.checkpoints.length > 0.85) {
            this.win();
            this.canvas.style.transition = 'opacity 0.5s';
            this.canvas.style.opacity = '0';
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
